import { useContext } from 'react';
import { SessionContext } from '../../../contexts/SessionContext';

export function useSession() {
    const { state } = useContext(SessionContext);

    return state;
}
